import { fetchData } from 'services/api/core/applications'
import { getItem, setItem } from 'services/localStorage/cache'
import { addDays } from 'date-fns'

async function fetchLoanApplication(applicationId: string) {
  const cacheKey = `fetchLoanApplication:${applicationId}`
  const cacheValue = getItem(cacheKey)

  if (cacheValue) {
    return cacheValue
  }

  const response = await fetchData(applicationId)
  const data = {
    cellphone: `(${response.cellphone.code}) ${response.cellphone.number}`,
    email: response.email,
    professionalStatus: response.employments.professionalStatus,
    vehicleOwner: response.vehicleOwner,
    peopleId: response.people.id,
  }

  setItem(cacheKey, data, addDays(new Date(), 3))
  return data
}

export { fetchLoanApplication }
